export const TutorialNotificationStack = {
  flow: 'y',
  childExtends: 'TutorialNotification',
  position: 'relative',
  gap: 'X',
  width: 'H2',
  childrenAs: 'state',
  // Per-child dismissal now comes from TutorialNotification's own
  // `useCookie`/`if:` (inherited via childExtends — the same mechanism
  // TutorialGifsNotificationStack already relies on), so this no longer
  // hand-rolls its own cookie pre-filter. `if:false` never creates the DOM
  // node (smbls/packages/element/src/create.js), so a dismissed card
  // leaves no `:nth-child()` gap — behavior is identical, one fewer
  // bespoke path to keep in sync.
  children: [
    {
      key: 'explainCanvas',
      title: 'learn.coach.canvas.title',
      descr: 'learn.coach.canvas.descr',
      icon: 'resize.json',
      docsArticle: '/canvas-and-editor'
    },
    {
      key: 'explainRealtime',
      title: 'learn.coach.realtime.title',
      descr: 'learn.coach.realtime.descr',
      icon: 'realtime-move.json',
      docsArticle: '/publish'
    },
    {
      key: 'explainEditingAndNav',
      title: 'learn.coach.edit.title',
      descr: 'learn.coach.edit.descr',
      icon: 'double-click.json',
      docsArticle: '/building-in-symbols'
    }
  ],
  childProps: {
    ':nth-child(1)': {
      zIndex: 3,
      position: 'relative'
    },
    ':nth-child(2)': {
      pointerEvents: 'none',
      zIndex: 2,
      opacity: 0.9,
      position: 'absolute',
      transform: 'translate3d(0, -0.7em, 0) scale(0.95)'
    },
    ':nth-child(3)': {
      pointerEvents: 'none',
      zIndex: 1,
      opacity: 0.7,
      position: 'absolute',
      transform: 'translate3d(0, -1.2em, 0) scale(0.9)'
    }
  }
}
